import { Link, useParams } from "react-router-dom";
import { Users } from "lucide-react";
import Seo from "@/components/site/Seo";
import useFetch from "@/hooks/useFetch";
import { fileUrl } from "@/lib/api";
import NotFound from "./NotFound";

export default function PlayerProfile() {
  const { id } = useParams();
  const { data: p, loading, error } = useFetch(`/players/${id}`);
  const { data: teams } = useFetch("/teams", []);
  if (error) return <NotFound />;
  if (loading || !p) return <div className="min-h-screen" />;
  const team = (teams || []).find((t) => t.id === p.team_id);
  const s = p.stats || {};
  const rows = [["Matches", s.matches], ["Runs", s.runs], ["Highest", s.highest || "-"], ["Strike rate", s.strike_rate], ["Wickets", s.wickets], ["Best bowling", s.best_bowling || "-"], ["Economy", s.economy]];
  return (
    <section data-testid="player-profile" className="container-x grid gap-10 pb-20 pt-36 lg:grid-cols-[360px_1fr]">
      <Seo title={p.name} description={`${p.name} — ${p.player_role} in the Telangana–Andhra T10 League.`} />
      <div className="overflow-hidden rounded-md border border-white/10 bg-[#112240]">
        {p.photo ? <img src={fileUrl(p.photo)} alt={p.name} className="aspect-[4/5] w-full object-cover" /> : <div className="flex aspect-[4/5] items-center justify-center"><Users className="h-16 w-16 text-slate-600" /></div>}
      </div>
      <div>
        <p className="eyebrow">{p.player_role}</p>
        <h1 className="mt-3 font-display text-5xl uppercase sm:text-6xl">{p.name}</h1>
        <p className="mt-2 text-slate-400">{[p.district, p.state].filter(Boolean).join(", ")}</p>
        {team && <Link to={`/teams/${team.slug}`} className="mt-3 inline-block text-sm font-bold uppercase tracking-wider text-[#00E5FF]">{team.name} →</Link>}
        <div className="mt-6 flex flex-wrap gap-3 text-sm">
          <span className="rounded-full border border-white/15 px-4 py-1.5">{p.batting_hand}</span>
          <span className="rounded-full border border-white/15 px-4 py-1.5">{p.bowling_style}</span>
        </div>
        {p.bio && <p className="mt-6 max-w-2xl text-slate-300">{p.bio}</p>}
        <div data-testid="player-stats" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {rows.map(([l, v]) => (
            <div key={l} className="rounded-md border border-white/10 bg-[#0A192F] p-4">
              <p className="font-score text-3xl font-bold">{v ?? 0}</p>
              <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">{l}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
